import { createContext } from "react";

export const AlertContext = createContext({
  showAlert: () => {},
  showSuccess: () => {},
  showError: () => {},
  showWarning: () => {},
  showInfo: () => {},
});
